<template>
  <div class="card">
    <div class="card-content is-paddingless">
      <img class="image" v-if="imagePath" alt="" :src="imagePath"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { markdown } from '@/utils.js'
export default {
  name: 'archiveItem',
  props: ['item'],
  computed: {
    ...mapGetters(['chapter']),

    imagePath () {
      if (this.item.filename) {
        if (Array.isArray(this.item.filename)) {
          return require(`@/assets/images/${this.chapter.shortname}/archive/${this.item.filename[0]}`)
        } else {
          return require(`@/assets/images/${this.chapter.shortname}/archive/${this.item.filename}`)
        }
      } else {
        return false
      }
    },

    type () {
      if (this.item.objects) {
        return 'group'
      } else {
        return this.item.type
      }
    }
  },
  methods: {
    markdown: markdown
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ArchiveItem.vue?444261ba